<template>
  <div v-if="Object.keys(columns).length" class="list__item -heading">
    <div v-if="checkable" class="list__column list__checkable">
      <div class="checkbox-primary custom-control custom-checkbox">
        <input
          id="item-all"
          v-model="listCheckAll"
          :disabled="Object.keys(this.datas).length === 0"
          class="custom-control-input"
          name="listCheckAll"
          type="checkbox"
          value="1"
          @click="checkAll($event)"
        />
        <label class="custom-control-label" for="item-all"></label>
      </div>
    </div>
    <div
      v-for="(column, index) in columnsItem"
      :key="column.name"
      :class="
        (column.sortable ? 'list__sortable ' : '') +
        'list__column -heading textStyle w' +
        (type === 'template' && index === 0 ? ' template-col' : '') +
        (type === 'template' && index === 1 ? ' template-col-1' : '') +
        (type === 'training' && index === 1 ? ' training-col' : '') +
        (type === 'ypareo_reporting' && (index === 1 || index === 2) ? ' ypareo-col' : '') +
        (type === 'ypareo_reporting_view' && index === 2 ? ' ypareo-view-col' : '') +
        (shouldReduceWidth(index) ? ' -small' : '') +
        (shouldExpandWidth(index) ? ' -big' : '')
      "
      :style="'--maxColumn:' + nbColumns"
      @click="sort($event, column)"
    >
      <span
        :ref="'label-' + index"
        v-tooltip="{
          title: $t((column.tradPrefix ? column.tradPrefix + '.' : '') + column.name),
          hide: !overflowingColumns[index],
        }"
        class="list__label"
        >{{ $t((column.tradPrefix ? column.tradPrefix + "." : "") + column.name) }}</span
      >
      <FontAwesomeIcon
        v-if="column.sortable"
        :icon="'fa-light ' + (column.sortWay ? 'fa-sort-' + column.sortWay : 'fa-sort')"
      />
    </div>
    <div v-if="Object.keys(actions).length" :class="'list__action ' + (actions.length <= 2 ? 'small' : '')"></div>
  </div>
</template>

<script>
import { sortableTableManager } from "@/services/utilities/sortable-table-manager";

export default {
  name: "SortTableFirstRowComponent",
  props: {
    datas: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    checkable: {
      default: false,
      type: Boolean,
      required: false,
    },
    nbColumns: {
      type: Number,
      required: true,
    },
    actions: {
      default: () => [],
      type: Array,
      required: false,
    },
    type: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      listCheckAll: 0,
      columnsItem: [],
      overflowingColumns: {},
    };
  },
  watch: {
    columns() {
      this.getColumnsItem();
    },
    columnsItem() {
      this.$nextTick(() => {
        this.checkOverflows();
      });
    },
  },
  mounted() {
    this.getColumnsItem();
  },
  methods: {
    checkAll(e) {
      this.$emit("checkAll", e, this.listCheckAll);
    },

    sort(e, column) {
      this.$emit("sort", e, column);
    },

    getColumnsItem() {
      if (this.type === "driver_licence") {
        this.columnsItem = this.columns.filter((column) => column.name !== "Statut");
      } else {
        this.columnsItem = this.columns;
      }
    },

    shouldReduceWidth(index) {
      return sortableTableManager.shouldReduceColumn(this.type, index);
    },

    shouldExpandWidth(index) {
      return sortableTableManager.shouldExpandColumn(this.type, index);
    },

    checkOverflows() {
      const overflowing = {};
      this.columnsItem.forEach((column, index) => {
        const ref = this.$refs["label-" + index];
        const el = Array.isArray(ref) ? ref[0] : ref;
        if (el) {
          overflowing[index] = el.scrollWidth > el.clientWidth;
        }
      });
      this.overflowingColumns = overflowing;
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  min-height: 350px;
  position: relative;

  &__label {
    display: block;
    width: 98%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid $light-grey;
    padding-bottom: 8px;
    position: relative;

    @include up-to-lg {
      flex-direction: column;
    }

    @include dark-theme {
      color: $white;
    }

    &.-heading {
      font-weight: 700;
      font-size: 14px;

      @include up-to-lg {
        display: none;
      }

      .list__sortable {
        cursor: pointer;
        position: relative;

        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }

  &__column {
    padding-right: 15px;
    padding-top: 8px;
    min-width: 100px;

    &.-heading {
      text-transform: capitalize;
    }

    &.text-overflow-hidden {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    @include up-to-lg {
      &:nth-child(1) {
        font-weight: 700;
        font-size: 16px;
      }
    }

    &.training-col {
      width: 22% !important;
    }

    &.template-col {
      width: 1% !important;

      @include up-to-lg {
        width: 100% !important;
      }
    }

    &.template-col-1 {
      width: 25% !important;

      @include up-to-lg {
        width: 100% !important;
      }
    }

    &.ypareo-col {
      width: 15% !important;
    }

    &.ypareo-view-col {
      width: 50% !important;
    }

    .btn-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 5px;

      &:hover,
      &:focus {
        border: 1px solid $blue;
      }
    }
  }

  &__action {
    width: 15%;

    &.-row {
      display: flex;
      justify-content: flex-end;
    }

    &.small {
      width: 7%;
    }

    @include up-to-lg {
      width: 100%;
      margin: 8px 0;
    }
  }
}
</style>
